up.compiler('[faq]', (element: HTMLDetailsElement) => {
  const summary = element.querySelector<HTMLElement>('.faq--summary')!
  const indicator = summary.querySelector<HTMLElement>('.faq--indicator')!

  const toggleIndicator = () => {
    // happens before the dialog state gets changed
    if (element.open) {
      indicator.textContent = '(ausklappen)'
    } else {
      indicator.textContent = '(einklappen)'
    }
  }

  up.on(summary, 'click', () => {
    toggleIndicator()
  })
})
